/* BASIQ · Header: selector de país / idioma
   Escritorio: desplegable con buscador bajo el botón.
   Móvil: hoja inferior deslizable (mismo estilo que el footer).
   El panel se mueve al <body> mientras está abierto para que el header fijo no lo recorte;
   sus botones usan form="..." así que siguen enviando el formulario de Shopify. */
(function () {
  'use strict';

  var MQ = window.matchMedia('(max-width: 989px)');
  var current = null;
  var bg = null;
  var locked = false;

  function norm(t) {
    return String(t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim();
  }

  function filter(input) {
    var panel = input.closest('[data-bh-loc-panel]');
    if (!panel) return;
    var q = norm(input.value);
    var items = panel.querySelectorAll('li[data-bh-name]');
    var shown = 0;
    for (var i = 0; i < items.length; i++) {
      var hit = !q || norm(items[i].getAttribute('data-bh-name')).indexOf(q) !== -1;
      items[i].hidden = !hit;
      if (hit) shown++;
    }
    var empty = panel.querySelector('[data-bh-loc-empty]');
    if (empty) empty.hidden = shown > 0;
  }

  function headerPause(on) {
    var wrapper = document.querySelector('.basiq-header-wrapper');
    if (!wrapper) return;
    if (on) wrapper.dataset.dropdownOpen = 'true';
    else delete wrapper.dataset.dropdownOpen;
  }

  function backdrop(on) {
    if (on) {
      if (!bg) {
        bg = document.createElement('div');
        bg.className = 'bh-loc-bg';
        bg.addEventListener('click', close);
        document.body.appendChild(bg);
      }
      bg.hidden = false;
      window.requestAnimationFrame(function () { bg.classList.add('is-on'); });
    } else if (bg) {
      bg.classList.remove('is-on');
      bg.hidden = true;
    }
  }

  function lock(on) {
    if (on === locked) return;
    locked = on;
    if (window.BasiqScrollLock) {
      if (on) window.BasiqScrollLock.lock(); else window.BasiqScrollLock.unlock();
    } else {
      document.documentElement.style.overflow = on ? 'hidden' : '';
    }
  }

  function place() {
    if (!current) return;
    var p = current.panel;
    if (MQ.matches) {
      p.style.top = '';
      p.style.right = '';
      return;
    }
    var r = current.btn.getBoundingClientRect();
    p.style.top = Math.round(r.bottom + 10) + 'px';
    p.style.right = Math.max(12, Math.round(window.innerWidth - r.right)) + 'px';
  }

  function open(root) {
    close();
    var btn = root.querySelector('[data-bh-loc-btn]');
    var panel = root.querySelector('[data-bh-loc-panel]');
    if (!btn || !panel) return;

    current = { root: root, btn: btn, panel: panel };
    document.body.appendChild(panel);
    panel.classList.toggle('is-sheet', MQ.matches);
    panel.hidden = false;
    place();
    window.requestAnimationFrame(function () { panel.classList.add('is-open'); });

    btn.setAttribute('aria-expanded', 'true');
    headerPause(true);
    if (MQ.matches) {
      backdrop(true);
      lock(true);
    }

    var list = panel.querySelector('.bh-loc__list');
    var cur = list && list.querySelector('[aria-current="true"]');
    if (list) list.scrollTop = cur ? Math.max(0, cur.closest('li').offsetTop - list.clientHeight / 2) : 0;

    /* En ordenador el cursor va directo al buscador; en móvil no, para no tapar la lista con el teclado */
    var search = panel.querySelector('[data-bh-loc-search]');
    if (search && !MQ.matches) search.focus({ preventScroll: true });
  }

  function close() {
    if (!current) return;
    var c = current;
    current = null;

    c.panel.classList.remove('is-open', 'is-sheet');
    c.panel.hidden = true;
    c.panel.style.top = '';
    c.panel.style.right = '';
    var search = c.panel.querySelector('[data-bh-loc-search]');
    if (search) {
      search.value = '';
      filter(search);
    }
    if (document.body.contains(c.root)) c.root.appendChild(c.panel);
    else if (c.panel.parentNode) c.panel.parentNode.removeChild(c.panel);

    c.btn.setAttribute('aria-expanded', 'false');
    backdrop(false);
    lock(false);
    headerPause(false);
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var btn = e.target.closest('[data-bh-loc-btn]');
    if (btn) {
      var root = btn.closest('[data-bh-loc]');
      if (current && current.root === root) close();
      else open(root);
      return;
    }

    if (e.target.closest('[data-bh-loc-close]')) {
      close();
      return;
    }

    if (current && !e.target.closest('[data-bh-loc-panel]')) close();
  });

  document.addEventListener('input', function (e) {
    if (e.target.matches && e.target.matches('[data-bh-loc-search]')) filter(e.target);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && current) {
      var b = current.btn;
      close();
      b.focus();
      return;
    }
    /* Enter en el buscador elige el primer país que coincide */
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-bh-loc-search]')) {
      e.preventDefault();
      var panel = e.target.closest('[data-bh-loc-panel]');
      var first = panel && panel.querySelector('li[data-bh-name]:not([hidden]) button');
      if (first) first.click();
    }
  });

  window.addEventListener('resize', place);
  window.addEventListener('scroll', function () { if (current && !MQ.matches) place(); }, { passive: true });
  if (MQ.addEventListener) MQ.addEventListener('change', close);

  /* Editor de Shopify: si se recarga el header con un panel abierto, se limpia */
  document.addEventListener('shopify:section:unload', close);
})();
